<template>
  <div v-if="currentAssessment && currentAssessment.Id">
    <div id="assessment-start" class="assessment-start">
      <div class="form-row cta-group">
        <a role="navigation" href="#" @click="routeToOverview()" @keydown.enter="routeToOverview()" class="back-assessment-link"
          ><span class="angle-circle-left-green"></span><div>Back to <strong>start page</strong></div></a
        >
      </div>
      <h1 class="page-title">{{ currentAssessment.Name }}</h1>
      <div class="row">
        <div class="col-md-8">
          <div class="html-content" v-html="currentAssessment.StartAssessmentIntroduction"></div>
        </div>
        <div class="col-md-4 d-flex justify-content-center">
          <button 
            class="cta-white-219 d-flex align-items-center justify-content-center"
            @click="openModal()"
            @keydown.enter="openModal()"
            
            ><span>Reset this tool</span></button
          >
        </div>
      </div>

      <div class="list-group">
        <button
          class="list-group-item p-3 mb-3"
          v-for="standard in currentAssessment.Standards"
          :key="standard.Id"
          @click="routeToStandard(currentAssessment.Id, standard.Id)"
          @keydown.enter="routeToStandard(currentAssessment.Id, standard.Id)"
          tabindex="0"
        >
        <div class="w-100 d-flex justify-content-between flex-md-row flex-column">
          <div class="name">{{ standard.Name }}</div>
          <div class="body">
            {{ countStandardQuestions(standard) }} question{{
              countStandardQuestions(standard) === 1 ? "" : "s"
            }}
           
          </div>
          </div>
           <span class="align-self-center angle-right-grey"></span>
        </button>
      </div>

      <div class="pack"
        v-if="
          currentAssessment.InformationPackUrl &&
            currentAssessment.InformationPackUrl !== ''
        "
      >
        <div class="info-pack">{{ currentAssessment.InformationPackText }}</div>
        <button 
          class="cta-white-332 d-flex align-items-center justify-content-center"
          @click="DownloadPack(currentAssessment.InformationPackUrl)"
           @keydown.enter="DownloadPack(currentAssessment.InformationPackUrl)"
          
          ><span>{{ currentAssessment.InformationPackCta }}</span><span class="angle-right-white"></span></button
        >
      </div>
    
    <div class="space"></div>
    </div>

    <div>
      <AssessmentModal
        v-show="showModal"     
        :isOpen="showModal"  
        :satId="satId" 
        @handleCancel="closeModal"
      />
    </div>

  </div>
        
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import {
  GET_SATCONTENTACTION,
  GET_SATSAVEDDATAACTION
} from "../store/mutation-types";
import { privateRouter } from "../router";
import AssessmentModal from "@/components/assessment-start-modal";
export default {
  name: "AssessmentStart",
  data() {
    return {
      //currentSat: {},
      //satIdData: 0
      showModal: false
    };
  },
  components: {
    AssessmentModal
  },
  props: {
    satId: {
      type: Number,
      default: () => 0
    },
    // showModal: {
    //   type: Boolean,
    //   default: () => false
    // }
  },
  async created() {
    //await this.loadData(this.satId);
    await this.loadSatContent();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapActions([GET_SATCONTENTACTION, GET_SATSAVEDDATAACTION]),
    async loadSatContent() {
      if (!this.satContent || !this.satContent.Tools) {
        // get satContent from API if not in the store (e.g. hitting this route before overview page)
        await this.getSatContentAction();
      }
    },
    countStandardQuestions(standard) {
      // get sum of all questions within standard's sections
      if (!standard.Sections || standard.Sections.length === 0) return 0;
      return standard.Sections.reduce(
        (count, sections) => count + sections.Questions.length,
        0
      );
    },
    routeToStandard(satId, standardId) {
      privateRouter.push({
        name: "AssessmentStandard",
        query: {
          satId: satId,
          standardId: standardId
        }
      });
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs"
      });
    },
    DownloadPack(url){
      window.open(url,"_blank");
    },    
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  },
  computed: {
    ...mapGetters(["getSatById"]),
    ...mapState({
      satContent: state => state.satContent,
      satSavedData: state => state.satSavedData
    }),
    currentAssessment: {
      get() {
        //return this.satSavedData.SavedAssessments[0].SAT_SavedResponses[0].PositiveResponse;
        //return this.getSatStandard(this.standardId)
        return this.satContent && this.satContent.Tools && this.satId
          ? this.satContent.Tools.filter(tool => {
              return tool.Id === this.satId;
            })[0]
          : {};
      },
      set(/* val */) {
        //this.$store.commit(`users/${SET_USER}`, { firstName: val });
        //this.$v.firstName.$touch();
      }
    }
    /* currentSat() {
                return this.getSatById(this.satIdData)
            },
            satIdData() {
                return this.$route.query.satId
                //if(this.satId === 0){return this.$route.query.satId} else {return this.satId} // get from querystring if not passed in prop
            } */
  }
};
</script>

<style lang="sass" scoped></style>
